export const checkinModalGlobal = {
  header: {
    phone: "Telefone",
    accommodation: "Acomodação",
    checkin: "Check-in",
    booking: "Reserva",
    notAvailable: "Não disponível",
    notLinked: "Não vinculado",
    defaultGuestName: "Hóspede",
  },
  roles: {
    botStaff: "BOT / STAFF",
    guest: "GUEST",
  },
  media: {
    imageAlt: "Imagem enviada",
    locationReceived: "📍 Localização recebida",
    openInMaps: "Abrir no Google Maps",
    viewCoordinates: "Ver coordenadas ({lat}, {lng})",
    viewFile: "Ver arquivo",
    document: "Documento",
  },
  dropzone: {
    text: "Solte para anexar arquivos",
  },
  failure: {
    notSent: "Não enviado",
    notSentDefault: "Não enviado",
    reasons: {
      paymentIssue: "problema de pagamento na conta do WhatsApp",
      cannotReceive: "o número não pode receber WhatsApp",
      downloadFailed: "o WhatsApp não conseguiu baixar o arquivo",
      templateMissingData: "faltam dados no modelo",
      requirementsNotMet: "a mensagem não atende aos requisitos do WhatsApp",
    },
  },
  mode: {
    ai: "IA",
    manual: "Manual",
    autoReplyBanner: "O agente está respondendo a este hóspede automaticamente.",
  },
  predefined: {
    header: "Respostas predefinidas",
    empty: "Nenhuma resposta predefinida encontrada",
  },
  input: {
    attachFile: "Anexar arquivo",
    placeholder: "Comece com / para escolher uma resposta predefinida.",
    removeFile: "Remover arquivo",
  },
  toasts: {
    noBookingLinkedSummary: "Nenhuma reserva vinculada",
    noBookingLinkedDetail: "Não há nenhuma reserva associada a esta conversa",
    errorSummary: "Erro",
    userIdError: "Não foi possível obter o ID do usuário",
    manualModeSummary: "Modo manual ativado",
    aiModeSummary: "Agente de IA ativado",
    manualModeDetail: "Você responderá às mensagens manualmente",
    aiModeDetail: "O bot responderá automaticamente",
    modeChangeError: "Não foi possível alterar o modo do chat",
    reactivateIdError: "Não foi possível identificar a conversa para reativá-la.",
    successSummary: "Sucesso",
    templateSentOk: "Modelo enviado com sucesso.",
    templateSentError: "Não foi possível enviar o modelo de reativação.",
    fileTypeSummary: "Tipo de arquivo não permitido",
    fileTypeDetail: "{name} não é uma imagem nem um PDF.",
    fileSizeSummary: "Arquivo muito grande",
    fileSizeDetail: "{name} excede o limite de 5MB.",
    sendError: "Não foi possível enviar a mensagem",
  },
};
